<template>
    <div class="not-found-page">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <span class="mb-20 head-text block">Ошибка 404</span>
                    <p class="mb-40">Такой страницы не существует или она была удалена</p>
                    <router-link :to="'/'"><Button text="Вернуться на главную" /></router-link>
                </div>
            </div>
        </div>
        <img src="/images/error.png" />
    </div>
</template>
<style lang="stylus" scoped>
@import '../styles/main.core.vars.styl';

.table-header
    background: $main_gradient
    color: #fff
    text-transform: uppercase
    font-weight: 700
    font-size: 13px

.white-panel
    overflow: hidden;

.desc
    font-weight: 400
    text-transform: none

.not-found-page
    background: $main_gradient
    height: calc(100vh - 80px)

.head-text
    color: #fff
    font-size: 60px
    margin-top: 20vh
    font-weight: 700

p
    color: #fff
    font-size: 20px

img
    position: fixed
    bottom: 0
    right: 0
    max-width: 60%

</style>
<script>
import { Component, Vue } from "vue-property-decorator";
import MainWrapper from "@/wrappers/MainWrapper.vue";
import Button from "@/components/Button.vue";
import Schedule from "@/components/Schedule.vue";

import moment from "moment";

import http from "@/methods/http.ts";

@Component({
  components: {
    Button,
  }
})
export default class NotFound extends Vue {

}
</script>